async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_drawer").innerHTML;
  document.querySelector(".u_cart_drawer").innerHTML = newBox;
}
$(function(){
  $(document).on('change','.u_cart_uppsell_var',function(e){
    e.stopPropagation()
    e.preventDefault()
    let sel_val =$(this).find('option:selected').val()
      let sel_image =$(this).find('option:selected').attr('data-image')
   $(this).closest('.u_cart_upsells_block').find('img').attr('src',sel_image)
  })
     function getCartCount() {
    $.getJSON('/cart.js', function(cart){ 
      var result = cart.item_count;
      console.log(result);     
        $('.cart-count-bubble span').text(result);
      });
    }
    $(document).ready(function(){
      getCartCount();
    });
     $(document).on('click','.drawer__close',function(){
        $('html').removeClass("u_overflow");
     })
       $(document).on('click','.cart-drawer__overlay',function(){
        $('.drawer__close').trigger('click')
     })
       $(document).on('click','.cart-remove-button,.quantity__button',function(){
       console.log('efef')
                                  setTimeout(function(){
                                   cart_reserved()
                                },2000)
     })
       $(document).on('click','.cart-remove-button,.quantity__button',function(){
      let gift_id = $('.u_ship_inp').attr('var-id').trim();
       setTimeout(function(){
               $.getJSON('/cart.js', function(cart){ 
      console.log(cart);
      var result = cart.item_count;
      console.log(result);
      if(result == '1' ){
         $.ajax({
        type:'POST',
        url:'/cart/change.js',
        data : {
        "id": gift_id  ,
        "quantity": 0,        
      },
 dataType: 'json',
        success: function(result){
        console.log('success');   
          setTimeout(function(){
          updateCartDrawer()
          getCartCount()
          },1000)
      },
             error: function(err) {
        console.log('error',err); 
      },
         complete: function() {
                      console.log('complete');           
      }
    })
  }
               })
       },1000)   
                  })
         cart_reserved() 
$(document).on('change','.u_ship_inp',function(){
    console.log('changed')
     if($(this).is(':checked')){
        console.log('checked')
       var vid = $(this).attr('var-id');
       let qty = $(this).attr('var-qty')
  let ths = $(this)
   $.ajax({
url:'/cart/add.js',
type:'post',
dataType:'json',
data:{
        quantity: qty, 
        id: vid
},
    success:function(){
      console.log('addon product addedd successfully');  
updateCartDrawer();
         setTimeout(function(){
        getCartCount();
         cart_reserved()                     
      }, 1000);
    },
       error:function(err){
          console.log("Error",err);
        }
})        
     }
     else{
        console.log('unchecked')
       var vid = $(this).attr('var-id');
  let ths = $(this)
   $.ajax({
url:'/cart/change.js',
type:'post',
dataType:'json',
data:{
        quantity: 0, 
        id: vid
},
    success:function(){
      console.log('addon product removed successfully');  
updateCartDrawer();
         setTimeout(function(){
        getCartCount(); 
        cart_reserved()                  
      }, 1000);
    },
       error:function(err){
          console.log("Error",err);
        }
})        
     }
  })
   cart_reserved()
   $(document).on('click','.product-form__submit',function(){   
                                  console.log('efef')
                                  setTimeout(function(){
                                   updateCartDrawer()
                                },500)
         })
    $(document).on('click','.product-form__submit',function(){   
                                  console.log('efef')
                                  setTimeout(function(){
                                   cart_reserved()
                                },2000)
         })

         function cart_reserved(){
           console.log('reserve------------')
                                    var sec2         = 300, //five minutes
    countDiv2    = document.getElementById("u_cart_reserved_timer"),
    secpass,
    countDown2   = setInterval(function () {
        'use strict';
        secpass2();
    }, 1200);

function secpass2() {
    'use strict';
    
    var min2     = Math.floor(sec2 / 60),
        remSec2  = sec2 % 60;
    
    if (remSec2 < 10) {
        
        remSec2 = '0' + remSec2;
    
    }
    if (min2 < 10) {
        
        min2 = '0' + min2;
    
    }
    countDiv2.innerHTML = min2 + ":" + remSec2;
    
    if (sec2 > 0) {
        
        sec2 = sec2 - 1;
        
    } else {
        
        clearInterval(countDown2);        
        countDiv2.innerHTML = '00:00';
   $('.u_cart_reserved').hide()
    }
}
}
$(document).on("click",".u_uppsell_cart_atc_btn",function (e) {
    e.stopPropagation();
    e.preventDefault();
    let form_data = $(this).closest("form").serialize();
    console.log("form data", form_data);
         let ths = $(this);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form_data,
      dataType: "json",
      beforeSend: function () {
        // setting a timeout
        console.log("before enter");
     ths.addClass("custom----disabled");
        ths.closest(".u_cart_upsells_block_row").attr("style", "opacity:.3");
        ths.closest(".u_cart_upsells_block").find(".u_cart_spinner").show();
      },
      success: function (result) {
        console.log("add to cart");
         updateCartDrawer();
             setTimeout(function(){
        getCartCount();                   
      }, 1000);
      },
      error: function (err) {
        console.log("error", err);
      },
      complete: function () {
              setTimeout(function () {
          ths.removeClass("custom----disabled");
          ths.closest(".u_cart_upsells_block_row").attr("style", "opacity:1");
          ths.closest(".u_cart_upsells_block").find(".u_cart_spinner").hide();
          cart_reserved()
        }, 1000);
      },
    });
  });
})